import styled from "styled-components";
import { calendlyUrl, instagramUrl, mapsUrl } from "../constants/links";
import { calendar, maps, instaColor } from "../img";

const FloatingLinks = () => (
  <StyledLinks className="floating-links">
    <a href={calendlyUrl} target="_blank" rel="noreferrer">
      <img src={calendar} alt="Calendly" loading="lazy" />
    </a>
    <a href={instagramUrl} target="blank">
      <img src={instaColor} alt="Instagram" loading="lazy" />
    </a>
    <a href={mapsUrl} target="blank">
      <img src={maps} alt="Google Maps" loading="lazy" />
    </a>
  </StyledLinks>
);

export default FloatingLinks;

const StyledLinks = styled.div`
  position: fixed;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  z-index: 5;
  a {
    height: 3rem;
    width: 3rem;
    transition: all 0.3s;
    img {
      width: 100%;
      height: 100%;
      object-fit: fit;
    }
    &:hover {
      transform: scale(1.2);
    }
  }
  @media all and (max-width: 2600px) {
    right: 2rem;
    height: 1.5rem;
    width: 1.5rem;
  }
  @media all and (max-width: 768px) {
    display: none;
  }
`;
